<template>
   <div id="page">
      <site-header title="Privacy Policy"/>
      <div class="content-row">
         <h4>
            Privacy Policy
            <br>Effective date: May 3rd, 2020
         </h4>

         <p>
            Your privacy is critically important to us.
         </p>

         <p>
            It is Company Inc.'s policy to respect your privacy regarding any informaion we may collect while operating our websites. This Privacy Policy applies to <a href="https://www.commentoid.com"> www.commentoid.com </a> (hereinafter, "Company," "us", "we", "Commentoid" or "www.commentoid.com"). We respect your privacy and are committed to protecting personally identifiable information you may provide us through the Website. We have adopted this privacy policy ("Privacy Policy") to explain what information may be collected on our Website and through our services, how we use this information, and under what circumstances we may disclose the information to third parties.
         </p>

         <p>
            Like most website operators, Company collects non-personally-identifying information of the sort that web browsers and servers typically make available, such as the browser type, language preference, referring site, and the date and time of each visitor request. Company's purpose in collecting non-personally identifying information is to better understand how Company visitors use its websites and services. From time to time, Company may release non-personally-identifying information in the aggregate, e.g., by publishing a report on trends in the usage of its websites.
         </p>

         <p>
            Company also collects potentially personally-identifying information like Internet Protocol (IP) addresses for visiting and logged in users that interact with our websites and services. Company only discloses logged in user and commenter IP addresses under the same circumstances that it uses and discloses personally-identifying information as described below:
         </p>   

         <h3> Gathering of Personally-Identifying Information </h3>

         <p>
            Certain visitors to Company's websites choose to interact with Company in ways that require Company to gather personally-identifying information. The amount and type of information that Company gathers depends on the nature of the interaction. For example, we ask visitors who sign up for a customer account at https://www.commentoid.com to provide their full name, phone number, email address and company name.
         </p>

         <p>
            The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.
         </p>


         <h3> Links To External Sites </h3>

         <p>
            Our Service may contain links to external sites that are not operated by us. If you click on a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy and terms and conditions of every site you visit.
         </p>

         <p>
            We have no control over, and assume no responsibility for the content, privacy policies or practices of any third party sites, products or services.
         </p>

         <h3> Protection of Certain Personally-Identifying Information </h3>

         <p>
            Company discloses potentially personally-identifying and personally-identifying information only to those of its employees, contractors and affiliated organizations that (i) need to know that information in order to process it on Company's behalf or to provide services available on the Company's websites, and (ii) that have agreed not to disclose it to others. Some of those employees, contractors and affiliated organizations may be located outside of your home country; by using Company's websites, you consent to the transfer of such information to them. Company will not rent or sell potentially personally-identifying and personally-identifying information to anyone. Other than to its employees, contractors and affiliated organizations, as described above, Company discloses potentially personally-identifying and personally-identifying information only in response to a subpoena, court order or other governmental request, or when Company believes in good faith that disclosure is reasonably necessary to protect the property or rights of Company, third parties or the public at large.
         </p>

         <p>
            If you are a registered user of https://www.commentoid.com and have supplied your email address, Company may occasionally send you an email to tell you about new features, solicit your feedback, or just keep you up to date with what’s going on with Company and our products. If you send us a request (for example via a support email or via one of our feedback mechanisms), we reserve the right to publish it in order to help us clarify or respond to your request or to help us support other users. Company takes all measures reasonably necessary to protect against the unauthorized access, use, alteration or destruction of potentially personally-identifying and personally-identifying information.</p>
         </p>
                  
         <h3> Aggregated Statistics </h3>
         <p>
            Company may collect statistics about the behavior of visitors to its websites. Company may display this information publicly or provide it to others. However, Company does not disclose your personally-identifying information.
         </p>

         <h3> Cookies </h3>
         <p>
            To enrich and perfect your online experience, Company uses "Cookies", similar technologies and services provided by others to display personalized content, appropriate advertising and store your preferences on your computer.
         </p>

         <p>
            A cookie is a string of information that a website stores on a visitor’s computer, and that the visitor’s browser provides to the website each time the visitor returns. Company uses cookies to help Company identify and track visitors, their usage of https://www.commentoid.com, and their website access preferences. Commentoid visitors who do not wish to have cookies placed on their computers should set their browsers to refuse cookies before using Company's websites, with the drawback that certain features of Company’s websites may not function properly without the aid of cookies.
         </p>

         <p>
            We may use cookies form third-party partners such as Google and Facebook for marketing purposes. These cookies allow us to display promotional material to you on other sites you visit across the Internet. Company may also share information about your behavior on our services with third parties in order to show you targeted advertisements and other content that has been customized for you.
         <p>
            By continuing to navigate our website without changing your cookie settings, you hereby acknowledge and agree to Company's use of cookies.
         </p>   

         <h3> Privacy Policy Changes </h3>
         <p>
            Although most changes are likely to be minor, Company may change its Privacy Policy from time to time, and in Company's sole discretion. Company encourages visitors to frequently check this page for any changes to its Privacy Policy. Your continued use of this site after any change in this Privacy Policy will constitute your acceptance of such change.
         </p>
      </div>
      <site-footer/>
   </div>
</template>

<script>
export default {
   data () {
      return {
         msg: ''
      }
   },
   methods: {
      preventMouseDown: (e) => {}
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#page {
   height: 99vh;   
   width: 64rem;
   margin: auto;
}

.content-row {
   margin: auto;
   width: 86%;
   text-align: justify;
}

/* + Responsive UI */
@media screen and (max-width: 1040px) {
   #page { 
      width: auto;
   }
}
/* - Responsive UI */
</style>



// WEBPACK FOOTER //
// src/components/site/Privacy.vue